import { proxyClientOptions, RestfulClient, Session, StockSymbol } from '@benzinga/session';
import { SafeError, SafePromise } from '@benzinga/safe-await';
import { formatTickerToURLFriendly, isAbleToUseProxyRoutes } from '@benzinga/utils';
import { PeerQuotesResponse } from '../../entities';
import { QuotesEnvironment } from '../../environment';

export class QuotesPeerQuotesRestful extends RestfulClient {
  constructor(session: Session) {
    const env = session.getEnvironment(QuotesEnvironment);
    super(env.peerQuotesUrl, session, { authorization: true, 'x-device-key': true }, proxyClientOptions());
  }

  getPeerQuotes = async (symbol: StockSymbol, limit?: number): SafePromise<PeerQuotesResponse> => {
    if (!isAbleToUseProxyRoutes()) {
      return {
        err: new SafeError(
          'QuotesPeerQuotesRestful is client-only. On the server, use getPeerQuotesForSymbol or getRelatedSymbolPeerQuotes instead.',
          'peer_quotes_client_only',
        ),
      };
    }

    const ticker = formatTickerToURLFriendly(symbol);
    const url = this.URL(`quote/${ticker}/peers`, limit !== undefined ? { limit } : undefined);

    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };
}
